<script setup lang="ts">
import AppSidebar from '@/layouts/_AppSidebar.vue'

defineProps<{
  open: boolean
  username: string
}>()

const emit = defineEmits<{
  close: []
  logout: []
}>()

function onItemClick() {
  emit('close')
}
</script>

<template>
  <div class="drawer-root" :data-open="open ? '1' : '0'">
    <div class="drawer-overlay" @click="emit('close')" />
    <div class="drawer-panel" @click.stop>
      <AppSidebar
        :collapsed="false"
        :username="username"
        @logout="emit('logout')"
        @item-click="onItemClick"
      />
    </div>
  </div>
</template>

<style scoped>
.drawer-root {
  position: fixed;
  inset: 0;
  z-index: 1000;
  pointer-events: none;
}
.drawer-root[data-open='1'] { pointer-events: auto; }
.drawer-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0);
  transition: background 200ms;
}
.drawer-root[data-open='1'] .drawer-overlay { background: rgba(0, 0, 0, 0.5); }
.drawer-panel {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 280px;
  transform: translateX(-100%);
  transition: transform 200ms;
  background: var(--surface);
  box-shadow: var(--shadow-pop);
}
.drawer-root[data-open='1'] .drawer-panel { transform: translateX(0); }
.drawer-panel :deep(.sidebar) {
  width: 100%;
  border-right: none;
}
</style>
